exports.transition = require('transition-property')

exports.transform = require('transform-property')

exports.touchAction = require('touchaction-property')

exports.transitionend = require('transitionend-property')

exports.has3d = require('has-translate3d')



/*****************
 ** WEBPACK FOOTER
 ** ./~/prop-detect/index.js
 ** module id = 16
 ** module chunks = 0
 **/